import React from "react"
import { css } from "@emotion/core"
import { Link } from "gatsby"
import DarkmodeButton from "./darkmode-button"
import titleLogoSVG from "../images/logo.svg"

const Nav = () => (
  <nav
    css={css`
      height: 60px;
      width: 800px;
      @media (max-width: 800px) {
        width: 100vw;
      }
      margin: auto;
      margin-bottom: 50px;
      display: flex;
      align-items: center;
    `}
  >
    <Link
      to="/"
      css={css`
        background: #000;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        width: 120px;
        height: 60px;
        box-shadow: 0 5px 5px -1px rgba(0, 0, 0, 0.5);
      `}
    >
      <img
        src={titleLogoSVG}
        alt="Top page"
        css={css`
          width: 80px;
          margin-bottom: 0;
        `}
      />
    </Link>
    <div
      className="spacer"
      css={css`
        flex-grow: 1;
      `}
    ></div>
    <Link
      to="/about/"
      css={css`
        font-size: 1.5rem;
        display: block;
        margin-right: 20px;
        text-decoration: none;
        a& {
          color: var(--text-normal-color);
          font-weight: bold;
        }
      `}
    >
      About
    </Link>
    <DarkmodeButton />
  </nav>
)

export default Nav
